module.exports = __webpack_public_path__ + "img/thumb_09.07a23ba2.jpg";